var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16683 18.3332C3.94582 18.3332 3.73385 18.2454 3.57757 18.0891C3.42129 17.9328 3.3335 17.7208 3.3335 17.4998V2.49984C3.3335 2.27882 3.42129 2.06686 3.57757 1.91058C3.73385 1.7543 3.94582 1.6665 4.16683 1.6665H15.8335C16.0545 1.6665 16.2665 1.7543 16.4228 1.91058C16.579 2.06686 16.6668 2.27882 16.6668 2.49984V4.99984H15.0002V3.33317H5.00016V16.6665H15.0002V14.9998H16.6668V17.4998C16.6668 17.7208 16.579 17.9328 16.4228 18.0891C16.2665 18.2454 16.0545 18.3332 15.8335 18.3332H4.16683ZM15.0002 13.3332V10.8332H9.16683V9.1665H15.0002V6.6665L19.1668 9.99984L15.0002 13.3332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.cc41e7ed1eed00193958a456c77a4b22.svg";
export { ForwardRef as ReactComponent };